module.exports = __webpack_public_path__ + "img/pdf-icon-small.6ce73a99.svg";